// get all tags
export const tagsQuery = `*[_type == "tag" && (isArchived == false || !defined(isArchived))]{
    _id,
    title,
    slug,
    description
}`

// get one tag by its slug
export const tagQuery = `*[_type == "tag" && (isArchived == false || !defined(isArchived)) && slug.current == $slug][0]{
    _id,
    title,
    slug,
    description
}`

// get all posts under one tag
export const tagPostsQuery = `*[_type == "post" && (isArchived == false || !defined(isArchived)) && $tagId in tags[]._ref]{
    _id,
    title,
    slug,
    date,
    tags[]->{
        _id,
        title,
        slug
    },
    body
}`